import {filter, matches} from 'lodash-es';
import type {ReactElement} from 'react';

import type {SelectProps} from '@/components/common/Input';
import {Select} from '@/components/common/Input';
import {useCountryList} from '@/context/CountryListContext';
import type {AfriexCountry} from '@/types';
import {mapCountryCodeToFlags} from '@/utils/countries';

interface CountryPickersProps extends Omit<SelectProps, 'options'> {
  options?: {key: string; value: string}[];
  filter?: Partial<AfriexCountry>;
}

const mapOptionsToList = (
  options: AfriexCountry[],
  filters: Partial<AfriexCountry> = {},
) =>
  filter(options, matches(filters)).map((country: AfriexCountry) => ({
    value: country.iso2,
    key: `${country.name} ${mapCountryCodeToFlags(options)[country?.iso2] ?? ''}`,
  }));

const CountryPicker = ({
  filter = {},
  ...props
}: CountryPickersProps): ReactElement => {
  const {state: countryListState} = useCountryList();
  const {countryList} = countryListState;
  const options = mapOptionsToList(countryList || [], filter);
  return <Select {...props} options={options} />;
};
export default CountryPicker;
